import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../../config/component.config';
import { EModelProductLabel, EModelProductView } from '../local-model-carousel/local-model-carousel.interface';

export interface IModelCarouselData<I = IModelCarouselDataItem> extends NICmsContentComponent.IData, IModelCarouselLoadRequest<I>, ICmsComponentCwvConfig {
    isCarousel?: boolean;
    title: string;
    link?: string;
    cta_text: string;
    cta_link: string;
}

export interface IModelCarouselLoadRequest<I = IModelCarouselDataItem> {
    variant: EModelCarouselVariant | 'string';
    limit: number;
    ids: number[];
    category_id: number;
    verbosity?: number;
    items?: I[];
}

export enum EModelCarouselVariant {
    CategoryProducts = 'category',
    ModelsIds = 'ids',
    CustomElements = 'custom'
}

export interface IModelCarouselDataItem {
    id: number;
    product_view: EModelProductView;
    product_label: EModelProductLabel;
}
